/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BlogManagerCreateArticleRequest = {
  groupId: number;
  title: string;
  context: string;
  postDate?: string;
  openSatatus: BlogManagerCreateArticleRequest.openSatatus;
  releaseSetting: BlogManagerCreateArticleRequest.releaseSetting;
  imageIds: Array<string>;
  tagIds?: string;
  postGroupIds?: string;
};

export namespace BlogManagerCreateArticleRequest {
  export enum openSatatus {
    EDIT = "edit",
    OPEN = "open",
    Z_DELETE = "z_delete",
  }

  export enum releaseSetting {
    NOW = "now",
    DATE = "date",
  }
}
